import {PatientLookupActions} from "../const/ActionsConst";

const initialState = {
    searchValue: undefined,
    enteredDOB: undefined,
    enteredDOBValid: true,
    selected: undefined,
    patientsInfo: []
};

const patients = (state = initialState, action) => {
    switch (action.type) {
        case PatientLookupActions.CHANGE_PATIENT_SEARCH_VALUE:
            return {
                ...state,
                searchValue: action.newValue,
            };
        case PatientLookupActions.SET_PATIENTS_LIST:
            return {
                ...state,
                patientsInfo: action.patients
            };
        case PatientLookupActions.SELECT_PATIENT:
            return {
                ...state,
                selected: action.patient
            };
        case PatientLookupActions.CHANGE_PATIENT_DOB_VALUE:
            return {
                ...state,
                enteredDOB: action.dateOfBirth,
            };
        case PatientLookupActions.VALIDATE_ENTERED_DOB:
            return {
                ...state,
                enteredDOBValid: action.valid,
            };
        default:
            return state;
    }
};

export default patients;